"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChevronIcon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/**
 *
 */
function ChevronIcon() {
    return ((0, jsx_runtime_1.jsx)("svg", { width: "13", height: "9", viewBox: "0 0 13 9", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: (0, jsx_runtime_1.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.56131 5.67705L11.2721 0.966309L12.4506 2.14482L6.56131 8.03408L0.672049 2.14482L1.85056 0.966308L6.56131 5.67705Z", fill: "#3A3E41" }) }));
}
exports.ChevronIcon = ChevronIcon;
//# sourceMappingURL=ChevronIcon.js.map